<template>
<div>
    <div class="input-label pl-1 pt-2">{{label}}</div>
    <div class="colour-frame">

        <!-- Transparent button -->
        <div title="Transparent" :style="colourItemStyle(null)" class="clickable colour-item elevation-1 transparent-checkers" @click="$emit('input', null)">
        </div>

        <!-- Other Buttons -->
        <div class="clickable colour-item elevation-1" v-for="colour in colours" :style="colourItemStyle(colour)" @click="$emit('input', colour)" :key="colour">
        </div>

    </div>
</div>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'

export default {
    data() {
        return {
        
        }
    },

    components: {
        
    },
    
    props: {
        label: String,
        colours: Array,
        value: String,
    },

    computed: {
        attributes() {

        }
    },

    methods: {
        colourItemStyle(colour) {
            return {
                'background-color': colour || 'white',
                'border': (colour == this.value ? 'solid 4px #A9D0F5' : 'solid 3px white'),
            }
        },
    },

    created() {

    }
}
</script>

<style scoped>
.colour-frame {
    display:flex;flex-wrap:wrap;
}
.colour-item {
    width:30px; height:30px;margin:2px;
    border-radius: 50%;
    opacity: .8;
}

.colour-item:hover {
    opacity:1
}
   
</style>




// WEBPACK FOOTER //
// ColourBar.vue?1375f92c